import {gql} from '@apollo/client'

export const GET_CLINIC_PROFILE = gql`
  query getBusinessDetails($id: ID!) {
    getClinicProfile(clinicId: $id) {
      clinicId
      clinicState
      isProfileCompleted
      clinicManagerFirstName
      clinicManagerLastName
      clinicName
      clinicPhone
      clinicEmail
      clinicCity
      clinicState
      clinicLogo
      isApproved
      clinicAddress {
        street
        city
        state
        zipCode
        country
      }
      clinicTechnicalDetails {
        mciNumber
        stateCouncil
        speciality
      }
    }
  }
`
export const GET_BUSINESS_PROFILE = gql`
  query getBusinessDetails($id: ID!) {
    getBusinessDetails(businessProfileId: $id) {
      id
      userId
      isActive
      businessType
      isApproved
      isRejected
      rejectionReason
      businessRejectionDate
      businessStep {
        businessStepKeyValue {
          stepName
          isCompleted
          isVerified
        }
      }
      userProfile {
        firstName
        lastName
        email
        userId
        aadhaarCard
        bloodGroup
        advanceDegrees
        userTechDetails {
          mciNumber
          stateCouncil
          specialty
          isDoctorCertified
          doctorCertificates
        }
        isProfileCompleted
      }
      businessProfile {
        businessName
        businessEmail
        businessType
        countryCode
        businessPhone
        businessTechnicalDetails {
          mciNumber
          businessRegistrationNumber
        }
      }
      businessAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      userAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      createdDate
      updatedDate
      approvedDate
      approvedBy
    }
  }
`
export const GET_BUSINESS_USER_PROFILE = gql`
  query getBusinessDetails($id: ID!) {
    getBusinessDetails(businessProfileId: $id) {
      id
      userId
      isActive
      businessType
      isApproved
      businessStep {
        businessStepKeyValue {
          stepName
          isCompleted
          isVerified
        }
      }
      userProfile {
        firstName
        lastName
        email
        userId
        aadhaarCard
        bloodGroup
        advanceDegrees
        userTechDetails {
          mciNumber
          stateCouncil
          specialty
          isDoctorCertified
          doctorCertificates
        }
        isProfileCompleted
      }
      businessProfile {
        businessName
        businessEmail
        businessType
        countryCode
        businessPhone
        businessTechnicalDetails {
          mciNumber
          businessRegistrationNumber
        }
      }
      businessAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      userAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      createdDate
      updatedDate
      approvedDate
      approvedBy
    }
  }
`

export const GET_BUSINESS_USER_PROFILE_DATA = gql`
  query getBusinessUserProfile($userRoleId: ID!) {
    getBusinessUserProfile(userRoleId: $userRoleId) {
      userProfile {
        firstName
        lastName
        email
        userId
        userRoleId
        aadhaarCard
        bloodGroup
        advanceDegrees
        userTechDetails {
          mciNumber
          stateCouncil
          specialty
          isDoctorCertified
          doctorCertificates
        }
        isProfileCompleted
      }
      businessProfileData {
        businessName
        businessEmail
        countryCode
        businessPhone
        businessAddress {
          id
          zipCode
          street
          city
          district
          state
          country
        }
      }
      userAddress {
        id
        zipCode
        street
        city
        district
        state
        country
      }
      businessType
      businessProfileRole
      isRoleActive
      isBusinessDeactivated
      applicationRole
    }
  }
`

export const EDIT_BUSINESS_PROFILE = gql`
  mutation editDoctorProfile(
    $userRoleId: ID!
    $isActive: Boolean!
    $firstName: String!
    $lastName: String!
    $email: String
    $userTechDetails: userTechInput
    $businessName: String!
    $businessEmail: String!
    $countryCode: Int!
    $businessPhone: MobileNumber!
    $businessAddress: String!
    $businessZip: String!
    $businessCity: String!
    $businessDistrict: String
    $businessState: String!
    $businessCountry: String!
    $bloodGroup: String
    $aadhaarCard: String
    $advanceDegrees: String
  ) {
    editDoctorProfile(
      userRoleId: $userRoleId
      isActive: $isActive
      profileDataInput: {
        userProfileInput: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          aadhaarCard: $aadhaarCard
          bloodGroup: $bloodGroup
          advanceDegrees: $advanceDegrees
          userTechDetails: $userTechDetails
        }
        businessProfileInput: {
          businessName: $businessName
          businessEmail: $businessEmail
          countryCode: $countryCode
          businessPhone: $businessPhone
          businessAddress: $businessAddress
          businessZip: $businessZip
          businessCity: $businessCity
          businessDistrict: $businessDistrict
          businessState: $businessState
          businessCountry: $businessCountry
        }
      }
    ) {
      id
    }
  }
`

export const EDIT_BUSINESS_FEES = gql`
  mutation editEpulseFeesForBusiness(
    $businessProfileId: ID!
    $epulseFeesInput: [epulseFeesInputs!]
  ) {
    editEpulseFeesForBusiness(
      businessProfileId: $businessProfileId
      epulseFeesInput: $epulseFeesInput
    )
  }
`

export const EDIT_CLINIC_PROFILE = gql`
  mutation editMasterClinicProfile(
    $clinicId: ID!
    $clinicManagerFirstName: String!
    $clinicManagerLastName: String!
    $clinicName: String!
    $clinicCity: String!
    $clinicState: String!
    $mciNumber: String!
    $stateCouncil: String!
    $speciality: String!
  ) {
    editMasterClinicProfile(
      clinicId: $clinicId
      clinicInput: {
        clinicManagerFirstName: $clinicManagerFirstName
        clinicManagerLastName: $clinicManagerLastName
        clinicName: $clinicName
        clinicCity: $clinicCity
        clinicState: $clinicState
        clinicTechnicalDetails: {
          mciNumber: $mciNumber
          stateCouncil: $stateCouncil
          speciality: $speciality
        }
      }
    ) {
      clinicId
      clinicManagerFirstName
      clinicManagerLastName
    }
  }
`

export const REJECT_BUSINESS = gql`
  mutation rejectBusiness($userRoleId: ID!, $rejectionReason: String!) {
    rejectBusiness(userRoleId: $userRoleId, rejectionReason: $rejectionReason)
  }
`

export const UPDATE_CLINIC_STATUS = gql`
  mutation activeInactiveClinic($status: String!, $clinicId: ID!) {
    activeInactiveClinic(status: $status, clinicId: $clinicId)
  }
`
export const GET_CLINIC_PLAN = gql`
  query getMasterSubscription($clinicId: ID!) {
    getMasterSubscription(subscriptionRoleId: $clinicId) {
      id
      subscriptionRoleId
      billingPlanId
      pricingOptionId
      billingPlan {
        id
        name
        description
        features {
          id
          name
          description
        }
        pricingOptions {
          id
          price
          currency
          planIntervalUnit
          planIntervalValue
          totalAmount
        }
        trialPeriodValue
        trialPeriodUnit
      }
    }
  }
`

export const APPROVE_CLINIC = gql`
  mutation approveClinic(
    $clinicId: String!
    $clinicName: String!
    $discountCoupon: String
    $billingPlanId: ID!
    $pricingOptionId: ID!
  ) {
    approveClinic(
      clinicId: $clinicId
      clinicName: $clinicName
      billingPlan: {
        billingPlanId: $billingPlanId
        pricingOptionId: $pricingOptionId
        discountCoupon: $discountCoupon
      }
    ) {
      isRegisteredUser
    }
  }
`

export const APPROVE_BUSINESS = gql`
  mutation approveBusiness($userRoleId: ID!, $businessFeeDetail: [businessFeeDetail!]) {
    approveBusiness(userRoleId: $userRoleId, businessFeeDetail: $businessFeeDetail)
  }
`

export const GET_CLINIC_SUBSCRIPTION_HISTORY = gql`
  query getMasterSubscriptionHistory($clinicId: ID!) {
    getMasterSubscriptionHistory(subscriptionRoleId: $clinicId, listFilter: {page: 1, limit: 100}) {
      data {
        subscriptionRoleId
        billingPlanId
        pricingOptionId
        planName
        planDescription
        billingPricing {
          id
          price
          currency
          planIntervalUnit
          planIntervalValue
          totalAmount
        }
        status
        isCancelled
        cancelledDate
      }
    }
  }
`

export const GET_CLINIC_LIST = gql`
  query getBusinessList(
    $limit: Int!
    $page: Int!
    $businessType: String
    $name: String
    $countryCode: Int
    $mobileNumber: String
    $startDate: Date
    $endDate: Date
    $sortBy: String
    $sortOrder: Int
    $activeBusinesses: Boolean
  ) {
    getBusinessList(
      businessType: $businessType
      name: $name
      countryCode: $countryCode
      mobileNumber: $mobileNumber
      startDate: $startDate
      endDate: $endDate
      activeBusinesses: $activeBusinesses
      listFilter: {page: $page, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder}
    ) {
      data {
        id
        businessId
        businessType
        firstName
        lastName
        profilePhoto
        businessName
        isActive
        businessPhone
        businessRegisterDate
        userId
        registeredMobileNumber
        systemRole
        createdDate
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const CLININC_APPROVAL_REQUEST = gql`
  query getApprovalPendingBusinessList(
    $startDate: DateTime!
    $endDate: DateTime!
    $page: Int!
    $limit: Int!
    $sortBy: String
    $sortOrder: Int
    $status: businessRegStatusEnum
    $name: String
  ) {
    getApprovalPendingBusinessList(
      listFilter: {
        startDate: $startDate
        endDate: $endDate
        page: $page
        limit: $limit
        sortBy: $sortBy
        sortOrder: $sortOrder
      }
      name: $name
      status: $status
    ) {
      data {
        id
        businessType
        firstName
        lastName
        profilePhoto
        businessName
        businessRegisterDate
        businessId
        userId
        createdDate
        businessPhone
        registeredMobileNumber
        businessRejectionDate
        rejectionReason
        isRejected
      }
      total
      pageSize
      totalPages
      page
    }
  }
`

export const CLINIC_QUERY = gql`
  query getDashboardClinicList($startDate: Date!, $endDate: Date!) {
    getDashboardClinicList(
      listFilter: {startDate: $startDate, endDate: $endDate, page: 1, limit: 10}
    ) {
      data {
        id
        clinicId
        clinicManagerFirstName
        clinicManagerLastName
        clinicName
        clinicCity
      }
      pageSize
      total
      page
      totalPages
    }
  }
`
export const GET_APPROVED_BUSINESS_LIST = gql`
  query getDashboardBusinessList(
    $startDate: DateTime!
    $endDate: DateTime!
    $businessType: String!
  ) {
    getDashboardBusinessList(
      businessType: $businessType
      listFilter: {startDate: $startDate, endDate: $endDate, page: 1, limit: 10}
    ) {
      data {
        id
        systemRole
        businessId
        firstName
        lastName
        businessType
        businessName
        businessPhone
        createdDate
        userId
        registeredMobileNumber
      }
      pageSize
      total
      page
      totalPages
    }
  }
`

export const UPDATE_DOCUMENT = gql`
  mutation adminUpdateDoctorDocument(
    $documentId: ID
    $userId: ID!
    $documentTitle: String!
    $documentName: String!
    $documentUrl: String!
  ) {
    adminUpdateDoctorDocument(
      documentId: $documentId
      userId: $userId
      document: {
        documentName: $documentName
        documentTitle: $documentTitle
        documentUrl: $documentUrl
      }
    )
  }
`

export const DELETE_DOCUMENT = gql`
  mutation adminDeleteDoctorDocument($userId: ID!, $documentName: String!, $docUrl: String!) {
    adminDeleteDoctorDocument(documentName: $documentName, userId: $userId, docUrl: $docUrl)
  }
`

export const UPLOAD_FILE = gql`
  mutation uploadFileInOnlyS3($documentDetail: FileInput!) {
    uploadFileInOnlyS3(documentDetail: $documentDetail)
  }
`

export const GET_BUSINESS_FEES = gql`
  query getEpulseFeesForBusiness($businessProfileId: ID!) {
    getEpulseFeesForBusiness(businessProfileId: $businessProfileId) {
      id
      masterFeesId
      moduleName
      serviceLabel
      serviceKey
      fees
      feesType
      taxes
      isActive
      discountPercent
    }
  }
`
export const GET_BUSINESS_FEES_V2 = gql`
  query getEpulseFeesForBusinessV2($businessProfileId: ID!) {
    getEpulseFeesForBusinessV2(businessProfileId: $businessProfileId) {
      data {
        id
        masterFeesId
        moduleName
        serviceLabel
        serviceKey
        fees
        feesType
        taxes
        isActive
        discountPercent
      }
      serviceType
    }
  }
`

export const BUSINESS_FEE_HISTORY = gql`
  query getEpulseFeesHistoryForBusiness($limit: Int!, $page: Int!, $businessId: ID!) {
    getEpulseFeesHistoryForBusiness(
      BusinessId: $businessId
      listFilter: {page: $page, limit: $limit}
    ) {
      data {
        id
        masterFeesId
        moduleName
        serviceLabel
        fees
        feesType
        validFrom
        validTill
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const GET_BUSINESS_APPOINTMENT_FEES_FOR_ALL = gql`
  query getBusinessAppointmentFeesForAllDoctors($id: ID!) {
    getBusinessAppointmentFeesForAllDoctors(businessProfileId: $id) {
      id
      staffRole
      userId
      doctorFees {
        id
        consultationFee
        bookingFee
        videoConsultingFee
        audioCallFee
        currency
        version
      }
      firstName
      lastName
    }
  }
`
export const ACTIVATE_DEACTIVATE_BUSINESS = gql`
  mutation activateDeactivateBusiness($businessAdminRoleId: ID!) {
    activateDeactivateBusiness(businessAdminRoleId: $businessAdminRoleId)
  }
`
